RivalIQ.module('data', function (data, App, Backbone, Marionette, $, _) {

    'use strict';

    function getActiveFacebookAdAccountIdsForLandscape(landscapeId) {
        if (landscapeId === RivalIQ.state.landscape.id) {
            return RivalIQ.state.landscape.get('activeFacebookAdAccounts');
        } else {
            const landscape = _.find(RivalIQ.state.user.get('landscapes'), {
                id: landscapeId
            });
            return _.get(landscape, ['settings', 'activeFacebookAdAccounts'], []);
        }
    }

    const Alerts = RivalIQ.data.CacheLayer.extend({
        name: 'Alerts',
        cacheKeys: [
            'landscapeId',
            'startDate',
            'endDate',
            'companySetDescriptor',
            'companyId',
            'activeSources',
            'channel',
            'class',
            'limit',
            'activeFacebookAdAccountIds'
        ],

        loadData: function (attrs) {
            const collection = new RivalIQ.apps.Alerts.collections.Alerts.createFromOptions(attrs);

            return collection.fetch({
                data: {
                    activeSources: attrs.activeSources
                }
            }).then(function () {
                return collection;
            });
        },

        fetch: function (props) {
            const me = this;

            return me.getOrLoad({
                landscapeId: props.landscapeId,
                startDate: props.timePeriod.mainPeriodStart,
                endDate: props.timePeriod.mainPeriodEnd,
                companySetDescriptor: props.companySetDescriptor,
                companyId: props.companyId,
                activeSources: props.activeSources,
                channel: props.channel,
                class: props.eventClass,
                limit: props.limit,
                activeFacebookAdAccountIds: getActiveFacebookAdAccountIdsForLandscape(props.landscapeId)
            });
        }
    });

    data.alerts = new Alerts();
});
